import { render, staticRenderFns } from "./GlobalMenu.vue?vue&type=template&id=fc8518ae&scoped=true"
import script from "./GlobalMenu.vue?vue&type=script&lang=ts"
export * from "./GlobalMenu.vue?vue&type=script&lang=ts"
import style0 from "./GlobalMenu.vue?vue&type=style&index=0&id=fc8518ae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8518ae",
  null
  
)

export default component.exports